import { render, staticRenderFns } from "./ChangePosition.vue?vue&type=template&id=35cc92a0&scoped=true&"
import script from "./ChangePosition.vue?vue&type=script&lang=js&"
export * from "./ChangePosition.vue?vue&type=script&lang=js&"
import style0 from "./ChangePosition.vue?vue&type=style&index=0&id=35cc92a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cc92a0",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QBtn});
